import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import AppTheme from '../themes/AppTheme';
import SignInCard from '../components/SignInCard';
import {useContext, useEffect, useState} from "react";
import {useLocation} from "react-router";
import {githubSignInCallback, googleSignInCallback} from "../apis/junkyard";
import {
  GithubSignInCallbackRequest,
  AuthenticationState,
  GoogleSignInCallbackRequest, LoginType
} from "../utils/types";
import {AuthContext} from "../components/AuthContext";
import { useNavigate } from "react-router";
import JunkyardCardContainer from "../components/JunkyardCardContainer";

// Sources
// https://mui.com/material-ui/getting-started/templates/
// https://github.com/mui/material-ui/tree/v7.1.0/docs/data/material/getting-started/templates/sign-in-side

export default function SignInSide(props: { disableCustomTheme?: boolean }) {

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate(); // Add this at the component level
  let [code, setCode] = useState<string | null>(queryParams.get('code'));
  let [state, setState] = useState<string | null>(queryParams.get('state'));

  const getLoginTypeFromPath = (): LoginType | undefined => {
    if (location.pathname.includes("github")) {
      return LoginType.github;
    } else if (location.pathname.includes("google")) {
      return LoginType.google;
    }
    return undefined;
  }

  // TODO: Implement for google callback
  useEffect(() => {
    async function doCallback() {

      // Extract query parameters from URL
      if (code !== null && state !== null) {
        try {
          let loginType = getLoginTypeFromPath();
          let resp = null;
          if (loginType === LoginType.github) {
            resp = await githubSignInCallback({
              code: code,
              state: state,
            } as GithubSignInCallbackRequest)
          } else if (loginType === LoginType.google) {
            resp = await googleSignInCallback({
              code: code,
              state: state,
            } as GoogleSignInCallbackRequest)
          } else {
            throw new Error("Unable to login with method: " + loginType);
          }
          const response = resp as AuthenticationState;
          if (response.junkyard_access_token) {
            authContext.storeAccessToken(response.junkyard_access_token);
            authContext.storeLoginType(response.login_type);
            console.debug("Set access token in local storage")
          }
          navigate("/");
        } catch (error) {
          console.error(error);
        }

      }
    }
    doCallback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, state]);

  return (
      <JunkyardCardContainer {...props}>
        <SignInCard />
      </JunkyardCardContainer>
  );}